import { render, staticRenderFns } from "./ProductInfoRecord.vue?vue&type=template&id=b42d23d4&"
import script from "./ProductInfoRecord.vue?vue&type=script&lang=js&"
export * from "./ProductInfoRecord.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports